import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_vue_apex_charts = _resolveComponent("vue-apex-charts")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createBlock(_component_v_expansion_panels, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_expansion_panel, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_expansion_panel_title, null, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("h3", null, "Summary", -1)
            ]))]),
            _: 1
          }),
          (_ctx.summary.category.unique.length > 0)
            ? (_openBlock(), _createBlock(_component_v_expansion_panel_text, {
                key: 0,
                class: "tw-flex-inline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: 4 }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summary.category.unique, (uniqueCategory, index) => {
                            return (_openBlock(), _createBlock(_component_v_checkbox, {
                              key: index,
                              density: 'compact',
                              label: 
                uniqueCategory +
                ': $' +
                _ctx.summary.category.sum[index].total.toFixed(2)
              ,
                              "hide-details": true,
                              modelValue: _ctx.summary.category.selected[index],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.summary.category.selected[index]) = $event),
                              onChange: _ctx.emitFilter
                            }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "onChange"]))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: 4 }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summary.BCJL.unique, (uniqueBCJL, index) => {
                            return (_openBlock(), _createBlock(_component_v_checkbox, {
                              key: index,
                              density: 'compact',
                              label: 
                uniqueBCJL + ': $' + _ctx.summary.BCJL.sum[index].total.toFixed(2)
              ,
                              "hide-details": true,
                              modelValue: _ctx.summary.BCJL.selected[index],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.summary.BCJL.selected[index]) = $event),
                              onChange: _ctx.emitFilter
                            }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "onChange"]))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: 4 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Total: " + _toDisplayString(_ctx.totalSum.toFixed(2)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_vue_apex_charts, {
                            type: "pie",
                            height: "250px",
                            width: "400px",
                            options: _ctx.chartOptionsCategory,
                            series: _ctx.seriesCategory
                          }, null, 8, ["options", "series"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_vue_apex_charts, {
                            type: "pie",
                            height: "250px",
                            width: "400px",
                            options: _ctx.chartOptionsBCJL,
                            series: _ctx.seriesBCJL
                          }, null, 8, ["options", "series"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}